import { render } from "./Pagination.vue?vue&type=template&id=58d5426e&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=58d5426e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\piyus\\OneDrive\\Documents\\Github\\admin-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d5426e"]])

export default __exports__